import { ApiError } from "@/api/client";

/** What a refused sign-in says, in plain words; a closed passkey prompt says nothing (null). */
const MESSAGES: Record<string, string> = {
  not_staff: "This address is not on this brand's team. Ask an owner to add you.",
  invalid_code: "That code is not right, or it has expired. Ask for a new one.",
  invalid_email: "Enter a valid email address.",
  too_many_attempts: "Too many tries. Ask for a new code.",
  rate_limited: "Too many requests. Wait a minute and try again.",
  email_unavailable: "This brand cannot send email yet. Use a passkey, or set up email sending.",
  passkeys_unavailable: "Passkeys are not set up for this brand yet.",
  invalid_passkey: "That passkey was not accepted here.",
};

export function failureMessage(failure: unknown): string | null {
  if (failure instanceof ApiError) return MESSAGES[failure.code] ?? `Sign-in did not work (${failure.code}).`;
  if (failure instanceof Error && (failure.name === "NotAllowedError" || failure.name === "AbortError")) return null;
  return "Sign-in did not work. Check your connection and try again.";
}

export function emailProblem(email: string): string | null {
  const value = email.trim();
  return value.length < 3 || value.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? "Enter a valid email address." : null;
}

/** The mailed code: six digits; spaces a mail client adds are dropped. */
export const normaliseCode = (code: string) => code.replace(/\s+/g, "");
export const codeProblem = (code: string) => (/^\d{6}$/.test(normaliseCode(code)) ? null : "Enter the six digit code from the mail.");
